import { render, staticRenderFns } from "./ProductListMobile.vue?vue&type=template&id=9b040bce&scoped=true"
import script from "./ProductListMobile.vue?vue&type=script&lang=js"
export * from "./ProductListMobile.vue?vue&type=script&lang=js"
import style0 from "./ProductListMobile.vue?vue&type=style&index=0&id=9b040bce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b040bce",
  null
  
)

export default component.exports